import { createAction, props } from '@ngrx/store';
import { Credentials } from '../reducers/onboarding-auth.reducer';

export enum OnboardingAuthActions {
  AccessTokenGranted = '[Onboarding Auth] Access token granted',
  TokenRefreshFailed = '[Onboarding Auth] Token refresh failed',
  TokenRefreshed = '[Onboarding Auth] Token refreshed',
  AccessTokenExpired = '[Onboarding Auth] Token expired',
  AdditionalScopesRequired = '[Onboarding Auth] Additional Scopes requested',
  LogoutOnboarding = '[Onboarding Auth] Logout onboarding',
}

export const accessTokenGranted = createAction(
  OnboardingAuthActions.AccessTokenGranted,
  props<Credentials>(),
);

export const tokenRefreshFailed = createAction(
  OnboardingAuthActions.TokenRefreshFailed,
);

// todo delete
export const tokenRefreshed = createAction(
  OnboardingAuthActions.TokenRefreshed,
  props<Credentials>(),
);

export const accessTokenExpired = createAction(
  OnboardingAuthActions.AccessTokenExpired,
);

export const additionalScopesRequired = createAction(
  OnboardingAuthActions.AdditionalScopesRequired,
  props<{ scopes: string[] }>(),
);

export const logoutOnboarding = createAction(
  OnboardingAuthActions.LogoutOnboarding,
);
